// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type KeyboardEvent } from 'react';
import { styled } from '@compiled/react';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import InlineDialog from '@atlaskit/inline-dialog';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

type Props = {
	errorMessages: string[] | string;
};

type State = {
	dialogOpen: boolean;
};

// eslint-disable-next-line jira/react/no-class-components
export default class ValidationError extends PureComponent<Props, State> {
	state = {
		dialogOpen: false,
	};

	onToggleDialog = () => {
		this.setState({
			dialogOpen: !this.state.dialogOpen,
		});
	};

	onToggleDialogKeypress = (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			this.onToggleDialog();
		}
	};

	getErrorMessages() {
		const { errorMessages } = this.props;
		if (!errorMessages) {
			return [];
		}
		if (typeof errorMessages === 'string') {
			return [errorMessages];
		}
		return errorMessages;
	}

	renderDialogContent() {
		const errorMessages = this.getErrorMessages();
		if (errorMessages.length === 1) {
			return <DialogContainer>{errorMessages[0]}</DialogContainer>;
		}
		return (
			<DialogContainer>
				<ul>
					{errorMessages.map((message, index) => (
						<li key={index}>{message}</li>
					))}
				</ul>
			</DialogContainer>
		);
	}

	render() {
		if (this.getErrorMessages().length) {
			return (
				<InlineDialog
					content={this.renderDialogContent()}
					placement="bottom-end"
					isOpen={this.state.dialogOpen}
				>
					<WarningContainer
						data-testid="servicedesk-automation-common.common.validation-error.warning-container"
						tabIndex={0}
						onClick={this.onToggleDialog}
						onKeyPress={this.onToggleDialogKeypress}
					>
						{/* @ts-expect-error - TS2769 - No overload matches this call. */}
						<WarningIcon LEGACY_size="large" color={token('color.icon.warning', colors.Y200)} />
					</WarningContainer>
				</InlineDialog>
			);
		}
		return null;
	}
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DialogContainer = styled.div({
	minWidth: '150px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WarningContainer = styled.div({
	cursor: 'pointer',
	'&:hover': {
		outline: 'none',
	},
});
